import { Button } from "@ligo/layout-design-core";
import { ReactComponent as CirclePlayIcon } from "assets/icons/circlePlay.svg";
import { PauseAlert } from "./styles";
import useViewModel from "./viewModel";

const Interval = () => {
  const vm = useViewModel();
  const { loading, selectedItem, formatedDuration } = vm;
  const { t, handleToAnswer } = vm;

  if (!selectedItem?.IsPause) return <></>;

  return (
    <PauseAlert>
      <div>
        <p>{selectedItem.DeEventType}</p>
        <span>{t("interval.description")}</span>
        <h3>{formatedDuration}</h3>
      </div>
      <Button
        $small
        loading={loading}
        icon={<CirclePlayIcon />}
        onClick={handleToAnswer}
      >
        {t("interval.toAnswer")}
      </Button>
    </PauseAlert>
  );
};

export default Interval;
